import React from 'react';
import { useCookies } from 'react-cookie';
import { ScrollToTop } from 'src/client/components/ui/ScrollToTop';
import { JoinButton } from 'src/client/components/buttons/JoinButton';
import styled from 'styled-components/macro';
import { useSelector } from 'src/client/redux';
import { usePromotions } from 'src/client/helpers/usePromotions';
import { MAM_COOKIE_NAME } from 'src/shared/constants/cookies';
import { FREE_TRIAL_FLOATER } from 'src/client/constants/joinCampaigns';

const SignupButton = styled(JoinButton)`
  border-radius: 3px;
  font-size: 1.15rem;
  margin: 0 3px;
  padding: 15px 15px 16px;
  vertical-align: middle;
  background: #fc4718;
  color: #fff;
  opacity: 0.8;

  :hover,
  :focus {
    text-decoration: none;

    opacity: 1;
  }
`;

const ScrollUpButton = styled.div<{ backgroundImage: string }>`
  width: 53px;
  height: 53px;
  display: inline-block;
  background: ${({ backgroundImage }) => `url(${backgroundImage})`} no-repeat center center;
  background-size: cover;
`;

type Props = {
  canShowMemberStartNow: boolean;
  setFreeTrialDialogOpen: (state: boolean) => void;
};

export const FreeTrialScrollToTop = (props: Props) => {
  const { user, loaded } = useSelector((state) => state.auth);
  const { showFreeTrialButton } = useSelector((state) => state.app.config);
  const { cdnUrl } = useSelector((state) => state.app);
  const site = useSelector((state) => state.site);
  const { isPromoActive } = usePromotions();

  const paCookieName = `${site.abbreviation}_PA`;
  const [cookies] = useCookies([MAM_COOKIE_NAME, paCookieName]);

  const { canShowMemberStartNow, setFreeTrialDialogOpen } = props;

  if (!loaded) return null;

  const handleSignupButtonClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();
    window.dataLayer.push({
      event: 'gaEvent',
      eventCategory: 'free-trial',
      eventLabel: 'dialog',
      eventAction: 'show',
    });
    setFreeTrialDialogOpen(true);
  };

  const isAffiliateUser = Boolean(cookies[MAM_COOKIE_NAME] || cookies[paCookieName]);

  const joinButtonText = () => {
    switch (true) {
      case canShowMemberStartNow:
        return (
          <SignupButton campaign={FREE_TRIAL_FLOATER} className="hidden-xs">
            JOIN NOW!
          </SignupButton>
        );

      // in order to see this button you must:
      //   1. Not be loggged in
      //   2. Not have any affiliate codes in your cookies
      //   3. Not be accessing the site during a network wide promo
      //   4. Have the button enabled on the site
      case !user && !isAffiliateUser && !isPromoActive && showFreeTrialButton:
        return (
          <SignupButton campaign={FREE_TRIAL_FLOATER} onClick={handleSignupButtonClick} className="hidden-xs">
            FREE TRIAL
          </SignupButton>
        );

      default:
        return null;
    }
  };

  return (
    <ScrollToTop>
      {joinButtonText()}
      <ScrollUpButton
        className="va-m inline-block btn-scroll-up hidden-xs"
        backgroundImage={`${cdnUrl}/img/scroll@2x.png`}
      />
    </ScrollToTop>
  );
};
